<div class="members-group-container" [ngClass]="{'_collapsed':group.collapsed}" [id]="'ig_' + group._id">

	<div class="_group-container-header">
		<div class="title">
			<span>{{group.name}}</span>
			<small [class.text-danger]="group._requiered" *ngIf="group.validationMessage">({{group.validationMessage}})</small>
		</div>
		<mat-icon class="collapsicon-caret" (mousedown)="collapseGroup(group)">keyboard_arrow_up</mat-icon>
	</div>

	<div class="_group-container-body" >
		<p class="_group-container-body-description" *ngIf="group.description"><i>{{group.description}}</i></p>

		<div class="mod-cards-container" >
			<div class="mod-card-multi"
				 *ngFor="let item of group.items | filterBy:{'_prepared':true, disabled: false}; let first = first"
				 [ngClass]="{'active':item._selected, '_disabled': item.stockDisabled}"
				 (mousedown)="toggleSelectionGroupItem(group, item)">
				<div class="card-member-h-img" *ngIf="group.showMemberImages"  [appBgImage]="item.imageURL" [defaultImage]="appService.images.meal_alt" [model]="item"></div>
				<div class="_content">

					<div class="_header">
						<mat-icon class="_check">{{ item._selected ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
						<div class="_title">
							{{item.name}}
							@if (item._selected && item._item._enableEdit && item._item?.summary) {
							<div class="_summary text-modification">
								{{item._item.summary.text}}
							</div>
							} @else if (showItemDescription && item._item.description) {
							<div class="_description">
								{{item._item.description}}
							</div>
							}
						</div>

						<div class="_price text-highlight" *ngIf="item.price || item._item.total">
							<span *ngIf="!item._selected && item.price">
								+{{item.price | lcurrency}}
							</span>
							<span *ngIf="item._selected && item._item.total > 0">
								+{{item._item.total | lcurrency}}
							</span>
						</div>

						<div class="_edit" *ngIf="item._selected && item._item._enableEdit">
							<button type="button" mat-icon-button (mousedown)="editItemGroupItem(group, item, $event)">
								<mat-icon svgIcon="edit"></mat-icon>
							</button>
						</div>

						<!--<div class="_edit" *ngIf="item._selected && group.memberSelection != 'multi'">
							<button type="button"  (mousedown)="clearSelectionGroupItem(group, item, $event)">
								<mat-icon svgIcon="trash"></mat-icon>
							</button>
						</div>-->

						<div class="_actions" *ngIf="item.count && group.memberSelection == 'multi'">
							<ng-container *ngIf="item.count">
								<button type="button" (mousedown)="addRemoveItem(group, item, false, $event)" [disabled]="!item.count">
									<mat-icon svgIcon="minus_circle"></mat-icon>
								</button>

								<div class="_quantity">
									{{item.count || '0'}}
								</div>
							</ng-container>

							<button type="button" (mousedown)="addRemoveItem(group, item, true, $event)">
								<mat-icon svgIcon="plus_circle"></mat-icon>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--END HORIZONTAL MODE-->
	</div>


</div>
